export default __webpack_public_path__ + "static/media/newspaper-regular.ac90366f.svg";